module.exports = __webpack_public_path__ + "static/scale-model-of-topeka-zoo-in-topeka-kansas-da0658abb92431db47115c7f11bae024.png";